'use client';

import { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import ensurePostHogClientInitialized from './ensurePostHogClientInitialized';

// Applies a resolved PDP bootstrap to posthog-js. Renders nothing: the layout
// reads the same promise through PDPLayoutRevampSeedBoundary.
const PostHogSeedInit = ({ contextPromise }) => {
  useLayoutEffect(() => {
    if (!contextPromise) {
      return undefined;
    }

    let isCancelled = false;

    // The promise arrives as React's server thenable. Its then() returns
    // undefined, so chaining catch() throws and the CMS boundary blanks the PDP.
    Promise.resolve(contextPromise)
      .then(context => {
        // No bootstrap means the flag was left to the browser: no distinct
        // id, a cookieless visitor, or a failed read. Starting posthog-js
        // here would beat PostHogDeferredInit and skip its OneTrust/GPC check.
        if (isCancelled || !context?.bootstrap) {
          return null;
        }

        return ensurePostHogClientInitialized({
          bootstrap: context.bootstrap,
          shouldUseCookielessMode: context.shouldUseCookielessMode,
        });
      })
      .catch(() => {
        // PostHog is optional telemetry; swallow init failures (ad blockers, etc.).
      });

    return () => {
      isCancelled = true;
    };
  }, [contextPromise]);

  return null;
};

PostHogSeedInit.propTypes = {
  contextPromise: PropTypes.object,
};

export default PostHogSeedInit;
